import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SuggestionsDto } from './suggestions.dto';


export class AllSuggestionsResponseModel extends GlobalResponseObject{
    data?: SuggestionsDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: SuggestionsDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}